import { requestOffersHistoryListingSpoilerActions, setCategoriesFilter } from './actions';
import { fetchOffersHistorySpoiler } from '../../services/offersHistory/fetchOffersHistorySpoiler';
import { TThunkAction } from '../../types/redux';
import { ERoomsCount } from '../../repositories/valuation-offer-history/entities/offer_history/OfferHistorySpoilerRequestV2Schema';
import { ERoomCount } from '@cian/valuation-main-filters-widget';
import { ESpoilerCategoryRequest, IOffersHistorySpoilerData, mapOfferCategoriesEnums } from '../../types/offerHistory';
import { fetchSuburbanOffersHistorySpoiler } from '../../services/offersHistory/fetchSuburbanOffersHistorySpoiler';
import {
  EQueryParameters as ESuburbanSpoilerCategory,
  EQueryParameters_1 as EReportMainCategory,
} from '../../repositories/valuation-offer-history/suburban/v1/get-offers-history-spoiler';
import { selectIsSuburban } from '../../selectors/filters';

const { success, request, failure } = requestOffersHistoryListingSpoilerActions;

const ROOMS_COUNT_MAPPER = {
  [ERoomCount.Studio]: ERoomsCount.Studio,
  [ERoomCount.OneRoom]: ERoomsCount.One,
  [ERoomCount.TwoRoom]: ERoomsCount.Two,
  [ERoomCount.ThreeRoom]: ERoomsCount.Three,
  [ERoomCount.FourRoom]: ERoomsCount.Four,
};

/**
 * Если отчет открыт из карточки объявления,
 * делаем запрос за спойлером истории объявлений с offerId, во всех
 * остальных случаях запрос с houseId
 */
export const getOffersHistorySpoiler =
  (category?: ESpoilerCategoryRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();
    const {
      filters: { address, houseId, area, roomsCount, category: pageCategory },
      page: {
        isFromOfferCard,
        queryParams: { offerId },
        dealType,
      },
    } = state;
    const isSuburban = selectIsSuburban(state);

    dispatch(request());

    let res: IOffersHistorySpoilerData;

    try {
      /**
       * Если category на входе задан - значит запрос за загородкой
       */
      if (isSuburban || category) {
        res = await fetchSuburbanOffersHistorySpoiler(context, {
          address,
          category: (category || pageCategory) as unknown as ESuburbanSpoilerCategory,
          reportMainCategory: pageCategory as unknown as EReportMainCategory,
        });
      } else {
        const basedParams = {
          totalArea: area as number,
          roomsCount: ROOMS_COUNT_MAPPER[roomsCount as ERoomCount],
          dealType,
          category,
        };
        const paramsRequest = isFromOfferCard && offerId ? { ...basedParams, offerId } : { ...basedParams, houseId };

        res = await fetchOffersHistorySpoiler(context, paramsRequest);
      }

      dispatch(success(res));

      if (res.filters?.activeCategory) {
        const activeCategory = mapOfferCategoriesEnums[res.filters.activeCategory];

        dispatch(setCategoriesFilter(activeCategory));
      }
    } catch (e) {
      dispatch(failure());
    }
  };
